import { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";

export const CustomTabs = ({ tabs, color = "info", border = true }) => {
	const [currentTab, setCurrentTab] = useState(0);

	return (
		<>
			<div className="d-flex justify-content-between align-items-end flex-grow-0 pb-1">
				<Nav pills className={`nav-pills-${color} mt-2`}>
					{tabs.map((tab, index) => (
						<NavItem key={index}>
							<NavLink
								className={`rounded px-3 py-1 ${currentTab === index && "active"}`}
								onClick={function noRefCheck() {
									setCurrentTab(index);
								}}
								style={{ cursor: "pointer" }}
							>
								<small className="font-weight-bold">{tab.title}</small>
							</NavLink>
						</NavItem>
					))}
				</Nav>
			</div>

			<TabContent activeTab={currentTab}>
				{tabs.map((tab, index) => (
					<TabPane
						tabId={index}
						key={index}
						style={{
							overflowX: "auto",
							// backgroundColor: "#1E1E2C",
							...(border && { border: "2px solid #ffffff25" }),
						}}
						className={`${border && "p-3"} rounded-lg`}
					>
						<tab.component />
					</TabPane>
				))}
			</TabContent>
		</>
	);
};
